import { Box } from "@mui/material";

export const DownloadIcon = (props) => {
  return (
    <Box
      data-testcomp="Icon_Download"
      sx={{
        display: "flex",
        opacity: props.disabled ? 0.3 : 1,
        cursor: props.disabled ? "not-allowed" : "pointer",
        width: "24px",
        height: "24px",
        "& svg": {
          "& g": {
            "& g": {
              transition: "all 0.5s ease-in-out",
            },
          },
        },
        "&:hover": {
          "& svg": {
            "& g": {
              "& g": {
                fill: "#ffd401",
              },
            },
          },
        },
      }}
      {...props}
    >
      <Icon {...props} />
    </Box>
  );
};

const Icon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd" transform="translate(5 3)">
        <g fill="#ADADAD" mask="url(#b)">
          <path id="a" d="M14 6h-4V0H4v6H0l7 7 7-7zM0 15v2h14v-2H0z" />
        </g>
      </g>
    </svg>
  );
};
